import * as React from 'react'
import { textVariants, type TextVariantProps } from './Text.variants'
import { cn } from '../../utils/cn'

export type TextProps = TextVariantProps &
  React.HTMLAttributes<HTMLElement> & {
    as?: React.ElementType
    children: React.ReactNode
  }

export default function Text({ as, variant = 'body', className, children, ...rest }: TextProps) {
  const Tag = (as ?? (variant === 'reader' ? 'p' : 'span')) as React.ElementType
  return (
    <Tag className={cn(textVariants({ variant }), className)} {...rest}>
      {children}
    </Tag>
  )
}
